var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { NumberWithUnitForm, translate } from '@lucidlink/uicore';
import { CACHE_SIZE_RANGES, CACHE_SIZE_UNITS_OPTIONS, SETTINGS_NUMBER_INPUT_NAME, SETTINGS_UNIT_INPUT_NAME, } from '#constants';
import { cacheSizeValidationRules, cacheSizeValidator, } from '../../../services/validation';
import { useLocalCacheSize } from './hooks';
const LOCAL_CACHE_SIZE_ID = 'local-cache-size';
const COMBOBOX_ID = 'unit';
const { LOWER, UPPER } = CACHE_SIZE_RANGES;
export const LocalCacheSize = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { initialNumberValue, initialUnitValue, isSuccess, labelDefault, labelTooltip, onSave, resetToDefault, } = useLocalCacheSize({
        data,
        filespaceId,
        workspaceId,
    });
    return (_jsx(NumberWithUnitForm, { cancelAriaLabel: translate('cancel changing local cache size'), clientErrorMessage: translate('Must be between {{LOWER}} and {{UPPER}}', {
            LOWER,
            UPPER,
        }), "data-testid": LOCAL_CACHE_SIZE_ID, initialNumberValue: String(initialNumberValue), initialUnitValue: initialUnitValue, inlineFormValue: `${String(initialNumberValue)} ${initialUnitValue}`, inputId: LOCAL_CACHE_SIZE_ID, isSuccess: isSuccess, label: translate('Local cache size'), labelDefault: labelDefault, labelTooltip: labelTooltip, numberInputName: SETTINGS_NUMBER_INPUT_NAME, numberInputRules: cacheSizeValidationRules(), numberInputValidator: cacheSizeValidator, onSave: onSave, resetToDefault: resetToDefault, saveAriaLabel: translate('save local cache size'), unitAriaLabel: translate('Unit'), unitInputName: SETTINGS_UNIT_INPUT_NAME, unitInputTestId: COMBOBOX_ID, unitOptions: CACHE_SIZE_UNITS_OPTIONS }));
};
_react_refresh_temp_1 = LocalCacheSize;
$RefreshReg$(_react_refresh_temp_1, "LocalCacheSize");
_react_refresh_temp_2(LocalCacheSize, "yT9Cf4cYYmneZsFKAsDp1+cVBKs=", false, () => [useLocalCacheSize]);
